import { getUserInfo } from '../api/main'

const state = {
  userInfo: {}
}
const mutations = {
  SET_USERINFO: (state, value) => {
    state.userInfo = value
  }
}
const actions = {
  getUserInfo({ commit }, userId) {
    return getUserInfo(userId).then(res => {
      commit('SET_USERINFO', res)
      return res
    })
  }
}
export default {
  state,
  mutations,
  actions
}
